import {
  ChakraBox,
  ChakraFlex,
  EquipUIFireflyV2Theme,
  FAIconName,
  Icon,
  Text,
  TextAreaInputV2,
} from '@equip.health/ui';
import {
  EditAttributeData,
  EditLevelAttributeData,
  EditTreatmentOverviewFormData,
} from '~/lib/types/notes/EditTreatmentOverviewFormData';
import { EditTreatmentOverviewFormExplanationStepAttributeLabel } from '~/components/common/TreatmentOverviewCard/EditTreatmentOverviewFormExplanationStepAttributeLabel';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { CarePlanEvents } from '~/analytics/carePlanEvents';

type Props = {
  label: string;
  placeholder: string;
  attributeKey: keyof EditTreatmentOverviewFormData;
  oldAttribute?: EditAttributeData | EditLevelAttributeData;
  newAttribute?: EditAttributeData | EditLevelAttributeData;
  onExplanationValueChange: (value: string) => void;
};

export const EditTreatmentOverviewFormExplanationsStepAttributeRow = ({
  label,
  placeholder,
  attributeKey,
  oldAttribute,
  newAttribute,
  onExplanationValueChange,
}: Props) => {
  const { trackEvent } = useAnalytics();
  return (
    <ChakraFlex width="100%">
      <ChakraFlex flex="1" flexDirection="column" gap="6px">
        <Text color="neutral.secondary" id="modality__title" variant="caption">
          {label}
          <span
            style={{
              color: EquipUIFireflyV2Theme.colors.critical.base,
              marginLeft: '6px',
            }}
          >
            *
          </span>
        </Text>
        <ChakraFlex alignItems="center" gap="10px">
          <EditTreatmentOverviewFormExplanationStepAttributeLabel
            attribute={attributeKey}
            isOld
            value={oldAttribute}
          />
          <Icon color="accent.blue" name={FAIconName.arrowRightRegular} />
          <EditTreatmentOverviewFormExplanationStepAttributeLabel
            attribute={attributeKey}
            value={newAttribute}
          />
        </ChakraFlex>
      </ChakraFlex>
      <ChakraBox flex="1">
        <TextAreaInputV2
          id={`${attributeKey}_explanation`}
          onChange={onExplanationValueChange}
          onFocus={() =>
            trackEvent(
              CarePlanEvents.clickIntoAttributeExplanationTextboxInEditOverviewModal,
            )
          }
          placeholder={placeholder}
          value={newAttribute?.explanation ?? ''}
        />
      </ChakraBox>
    </ChakraFlex>
  );
};
